import React from 'react';
import { Redirect } from 'react-router-dom';
import UploadContainer from './UploadFiles.container';
import { isNullUndefinedOrEmpty } from '../../utils';
import useGrouping from 'Common/Utils/Hooks/useGrouping';

const UploadFiles = props => {
	const grouping = useGrouping();
	if (isNullUndefinedOrEmpty(grouping)) {
		return <Redirect push to="/"></Redirect>;
	}

	return <UploadContainer grouping={grouping} {...props} />;
};

export default UploadFiles;
